module.exports = __webpack_public_path__ + "static/media/mouthFrownRight.ab51cb69.obj";